import { render, staticRenderFns } from "./list_avatar.vue?vue&type=template&id=4d482014&scoped=true&"
import script from "./list_avatar.vue?vue&type=script&lang=js&"
export * from "./list_avatar.vue?vue&type=script&lang=js&"
import style0 from "./list_avatar.vue?vue&type=style&index=0&id=4d482014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d482014",
  null
  
)

export default component.exports